import React from 'react';
import { useParams } from 'react-router';
import { GET_PAYMENTS_AND_FEES_RECEIPT } from 'store/queries';

import Spinner from 'admin-components/components/Spinner';
import { useManagedQuery } from 'utils/managedHooks';
import Receipt from './Receipt';

const Index = () => {
  const { reference } = useParams();
  const { data, loading } = useManagedQuery(GET_PAYMENTS_AND_FEES_RECEIPT, { variables: { reference }, fetchPolicy: 'network-only' });

  if (loading) {
    return <Spinner />;
  }

  return <Receipt reference={reference} booking={data.booking} />;
};

export default Index;
